import {
  Footer,
  GiftCardMessageWrapper,
  GiftCardSectionWrapper,
  GuaranteeIcons,
  Hr,
  ImageBlock,
  InfoLinks,
  MainBlock,
  MainContainer,
  ProductInfoBlock,
  ProductSections,
  ProductSectionsContainer,
  Separator,
  Sliders,
  StyledDetailsCard,
  StyledShopTheLookButton,
} from './ProductPage.styles'

const ProductPage = {
  GiftCardSectionWrapper,
  GuaranteeIcons,
  ImageBlock,
  MainBlock,
  MainContainer,
  ProductInfoBlock,
  ProductSections,
  ProductSectionsContainer,
  Sliders,
  StyledDetailsCard,
  StyledShopTheLookButton,
  Footer,
  Hr,
  InfoLinks,
  GiftCardMessageWrapper,
  Separator,
}

export { ProductPage }
